export default <const>[
  {
    id: 'ball',
    stage: 'baby',
    player_level: 1,
    encyclopedia_order: 101,
    name_jp: 'ぶるぶる科タマ属',
    name_en: 'ball',
    greetings_jp: '…\nん…？だれコロ？',
    greetings_en: '...\nWho are you...?',
    stomach_ini: 39,
    love_ini: 41,
    dirtiness_ini: 0,
    urine_ini: 0,
    tooth_acidity_ini: 0,
    stomach_sec: 18,
    love_sec: 24,
    dirtiness_sec: 30,
    urine_sec: 36,
    tooth_acidity_sec: 72,
    scared_coefficient: 2,
    next_weights: {
      crab: 500,
      hamster: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'starball',
    stage: 'baby',
    player_level: 1,
    encyclopedia_order: 102,
    name_jp: 'ぶるぶる科ホシタマ属',
    name_en: 'starball',
    greetings_jp: 'ひ…\nだれスタ？',
    greetings_en: '...\nWho are you...?',
    stomach_ini: 39,
    love_ini: 41,
    dirtiness_ini: 0,
    urine_ini: 0,
    tooth_acidity_ini: 0,
    stomach_sec: 18,
    love_sec: 24,
    dirtiness_sec: 30,
    urine_sec: 36,
    tooth_acidity_sec: 72,
    scared_coefficient: 2,
    next_weights: {
      turtle: 500,
      hamster: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'crab',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 201,
    name_jp: 'ぶるぶる科カニ属',
    name_en: 'crab',
    greetings_jp: 'ちょっとおっきくなったカニ！',
    greetings_en: 'I got a little bit bigger',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      dog: 500,
      seaotter: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'hamster',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 202,
    name_jp: 'ぶるぶる科ハム属',
    name_en: 'hamster',
    greetings_jp: 'おっきくなったハム！',
    greetings_en: 'I got bigger!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      cat: 500,
      seaotter: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'turtle',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 203,
    name_jp: 'ぶるぶる科カメ属',
    name_en: 'turtle',
    greetings_jp: '今後ともよろしくカメ',
    greetings_en: 'Thank you for your continued support',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      dog: 500,
      cat: 500,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'dog',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 301,
    name_jp: 'ぶるぶる科イヌ属',
    name_en: 'dog',
    greetings_jp: 'これからもいっぱい\n遊んでほしいヌ！\nキャンキャン！',
    greetings_en: 'Keep playing with me\b!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      whale: 500,
      giraffe: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'seaotter',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 302,
    name_jp: 'ぶるぶる科ラッコ属',
    name_en: 'seaotter',
    greetings_jp: 'これからもいっぱい\n遊んでほしいッコ！',
    greetings_en: 'Keep playing with me\b!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      whale: 500,
      giraffe: 500,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'cat',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 303,
    name_jp: 'ぶるぶる科ネコ属',
    name_en: 'cat',
    greetings_jp: 'よろしくだミャー。\nむにゃむにゃ…。',
    greetings_en: "I'm still sleepy...",
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      giraffe: 500,
      whale: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'whale',
    stage: 'adult',
    player_level: 1,
    encyclopedia_order: 401,
    name_jp: 'ぶるぶる科クジラ属',
    name_en: 'whale',
    greetings_jp: 'もうオトナなのラー。\nこれからもよろしくラー。',
    greetings_en: "Now I'm a real adult.",
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    next_weights: {
      ball: 500,
      starball: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'giraffe',
    stage: 'adult',
    player_level: 1,
    encyclopedia_order: 402,
    name_jp: 'ぶるぶる科キリン属',
    name_en: 'giraffe',
    greetings_jp:
      'こんなに大きくなったリン！\nこれから、もーーーーーっと、\n仲良くして欲しいリン！',
    greetings_en: 'I got this big! Pleaes play with me more!',
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    next_weights: {
      starball: 500,
      ball: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
];
